<template>
  <div>
    <div v-if="!slug">
      <section class="grid-flex wrap">
        <div class="item flex-1 box flex middle column">
          <div class="box-content w100">
            <div class="">
              <h2>Seu guia de configuração rápida.</h2>
            </div>
            <div class="margin-top-s">
              <p>Para a plataforma ficar 100% configurada é necessário realizar todos os passos abaixo.</p>
            </div>
  
            <!-- step 0 -->
            <div class="l-item w100">
              <div class="l-title flex between" @click="steps[1] = !steps[1]">
                <div><i class="fas fa-angle-right"></i> 1) Instalação da Tag de Acompanhamento (Pixel) no seu site. </div>
                <div v-show="false" class="status done">Feito</div>
              </div>
              <div v-if="steps[1]" class="l-description flex column">
                <p>Escolha uma das 3 formas possíveis para instalar nossa tag de acompanhamento em sua página.</p>
                <a class="margin-top-s" href="https://www.youtube.com/watch?v=6pdhhedlVUE" target="_blank"> Instalar Pixel manualmente</a>
                <a class="margin-top-s" href="https://www.youtube.com/watch?v=10mMeo84jRY" target="_blank"> Instalar via GTM</a>
                <a class="margin-top-s" href="https://www.youtube.com/watch?v=e1UxEnUMwy4" target="_blank"> Instalar via Plugin WordPress</a>
                <div v-if="false" class="margin-top-l" @click="updateStep(1)">
                  <div class="button secondary">
                    Marcar como Concluido
                  </div>
                </div>
              </div>
            </div>
            <!-- step 1 -->
            <div class="l-item w100">
              <div class="l-title flex between" @click="steps[2] = !steps[2]">
                <div><i class="fas fa-angle-right"></i> 2) Instalação do Código de Trackeamento</div>
                <div v-show="false" class="status">Pendente</div>
              </div>
              <div v-if="steps[2]" class="l-description flex column">
                <p>Como instalar os códigos de trackeamento dentro das plataformas de marketing.</p>
                <a class="margin-top-s" href="https://www.youtube.com/watch?v=0mx9ARUcWCI" target="_blank"> Instalando no Facebook Ads</a>
                <a class="margin-top-s" href="https://www.youtube.com/watch?v=KrCUNisMne0" target="_blank"> Instalando no Google Ads</a>
                <div v-if="false" class="margin-top-l" @click="updateStep(2)">
                  <div class="button secondary">
                    Marcar como Concluido
                  </div>
                </div>
              </div>
            </div>
            <!-- step 2 -->
            <div class="l-item w100">
              <div class="l-title flex between" @click="steps[3] = !steps[3]">
                <div><i class="fas fa-angle-right"></i> 3) Puxando dados de Marketing</div>
                <div v-show="false" class="status">Pendente</div>
              </div>
              <div v-if="steps[3]" class="l-description flex column">
                <p>Como fazer integraçẽs para puxar dados de marketing.</p>
                <a class="margin-top-s" href="https://www.youtube.com/watch?v=iUrml33_dYg" target="_blank"> Facebook Ads</a>
                <a class="margin-top-s" href="https://www.youtube.com/watch?v=ATttDc3zEQQ" target="_blank"> Google Ads</a>
                <div v-if="false" class="margin-top-l" @click="updateStep(3)">
                  <div class="button secondary">
                    Marcar como Concluido
                  </div>
                </div>
              </div>
            </div>
            <!-- step 3 -->
            <div class="l-item w100">
              <div class="l-title flex between" @click="steps[4] = !steps[4]">
                <div><i class="fas fa-angle-right"></i> 4) Retro Alimentação</div>
                <div v-show="false" class="status">Pendente</div>
              </div>
              <div v-if="steps[4]" class="l-description">
                <p>Adicione o seu Pixel dentro da único. Acesse Trackeamento -> Tags / Pixels. </p>
                <p class="margin-top-s">Adicione seu Pixel com Token para nossa api de conversão e retro alimentação dos dados funcionar corretamente.</p>
              </div>
            </div>
            <!-- step 4 -->
            <div class="l-item w100">
              <div class="l-title flex between" @click="steps[5] = !steps[5]">
                <div><i class="fas fa-angle-right"></i> 5) Recebendo dados das Vendas </div>
                <div v-show="false" class="status">Pendente</div>
              </div>
              <div v-if="steps[5]" class="l-description flex column">
                <p>Como fazer integraçẽos para puxar dados de vendas.</p>
                <a class="margin-top-s" href="https://www.youtube.com/watch?v=eq3vvM2Z_RY" target="_blank"> Via WebHook</a>
                <div v-if="false" class="margin-top-l" @click="updateStep(5)">
                  <div class="button secondary">
                    Marcar como Concluido
                  </div>
                </div>
              </div>
            </div>
            <!-- step 0 -->
            <div v-if="false" class="l-item w100">
              <div class="l-title flex between" @click="steps[6] = !steps[6]">
                <div>1) 12331231231</div>
                <div v-show="false" class="status">Pendente</div>
              </div>
              <div v-if="steps[6]" class="l-description">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Ducimus dignissimos alias quis in nesciunt repudiandae nam rem voluptates corporis sequi illum, magnam, suscipit fuga doloribus! Alias atque odio ea modi!
              </div>
            </div>
          </div>
          <div class="margin-top-s" style="margin-bottom: 16px;">
              Para acessar todo nosso help center basta   <a href="https://l.lh4.me/f3xgau" target="_blank">
              <b>clicar aqui</b>
              </a>
            </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "onboarding",
  components: {},
  data() {
    return {
      loading: false,
      steps: {
        1: true,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false,
        8: false,
      }
    };
  },
  mounted() {},
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  methods: {
    checkResource(name) {
      return this.account && this.account.resources.includes(name);
    },
  },
};
</script>

<style lang="scss" scoped>
.l-item {
  padding: 16px 4px;
  border-bottom: 1px solid var(--bg);
  
  .l-title {
    font-size: 16px;
    cursor: pointer;
    font-weight: 400;
    .status {
      font-size: 14px;
      color: var(--primary);
      font-weight: 800;
      &.done {
        color: green;
      }
    }
    i {
      color: var(--primary);
    }

  }
  .l-description {
    width: 100%;
    border: 1px solid var(--bg);
    border-radius: 8px;
    margin-top: 16px;
    padding: 16px;
    width: 100%;

  }
}


</style>
